import React from "react";
import { Spinner } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "#root/routes/constants";
import { Breadcrumbs } from "#root/components/Breadcrumbs";
import { TENANT_TYPE } from "#root/utils/tenants";
import { useCurrentTenant } from "#root/queries/local";
import { useTenantById } from "#root/queries/tenants";
import ActionCards, { CardProps } from "#root/components/ActionCards";
import "./styles.scss";

const OrganizationSettings: React.FC = () => {
  const navigate = useNavigate();

  const { data: currentTenantId } = useCurrentTenant();
  const { data: tenantResponse } = useTenantById({ id: currentTenantId || "" });
  const currentTenant = tenantResponse?.item;
  const tenantType = currentTenant?.type || TENANT_TYPE.RAPID_REUNIFICATION;

  const cardsDict: Record<string, CardProps> = {
    users: {
      image: "users",
      title: "Users",
      onClick: () => navigate(ROUTES.ORGANIZATION_SETTINGS.USERS_ADMINISTRATION)
    },
    locations: {
      image: "locations",
      title: "Locations",
      onClick: () => navigate(ROUTES.ORGANIZATION_SETTINGS.LOCATIONS)
    },
    defaultUnits: {
      image: "default-units",
      title: "Default Units",
      onClick: () => navigate(ROUTES.ORGANIZATION_SETTINGS.DEFAULT_UNITS)
    },
    accountRequests: {
      image: "user-account-requests",
      title: "User Account Requests",
      onClick: () => navigate(ROUTES.ORGANIZATION_SETTINGS.ACCOUNT_REQUESTS)
    },
    chiefComplaints: {
      image: "chief-complaints",
      title: "Chief Complaints",
      onClick: () => navigate(ROUTES.ORGANIZATION_SETTINGS.CHIEF_COMPLAINTS)
    },
    roles: {
      image: "roles",
      title: "Roles",
      onClick: () => navigate(ROUTES.ORGANIZATION_SETTINGS.ROLES)
    }
  };

  const defaultCards: CardProps[] = [
    cardsDict.users,
    cardsDict.locations,
    cardsDict.defaultUnits,
    cardsDict.accountRequests,
    cardsDict.chiefComplaints
  ];

  const tenantOverrides: Partial<Record<string, CardProps[]>> = {
    [TENANT_TYPE.MERRGE_211]: [
      cardsDict.users,
      cardsDict.locations,
      cardsDict.defaultUnits,
      cardsDict.accountRequests,
      cardsDict.roles
    ]
  };

  const getCards = (): CardProps[] =>
    (tenantOverrides[tenantType] || defaultCards).map(card => ({ ...card }));

  if (currentTenantId && !currentTenant) {
    return <Spinner size="large" />;
  }

  return (
    <div className="organization-settings">
      <div className="emc-page-header">
        <div className="emc-page-header__top-row">
          <div className="emc-page-header__breadcrumbs">
            <Breadcrumbs />
          </div>
        </div>
        <div className="emc-page-header__title">
          <h2>
            Organization Settings <div className="divider" />
          </h2>
        </div>
      </div>

      <ActionCards cards={getCards()} />
    </div>
  );
};

export default OrganizationSettings;
